import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { useEffect, useState } from "react";
import axios from "axios";
export default function SlideShow({ siteId, num_slides }) {
  const [allImages, setAllImages] = useState([]);
  useEffect(() => {
    async function getData() {
      const url = `https://api.floranya.co/slider`;

  const data = await axios.get(url);

  setAllImages(data.data);

    }
    getData();

  }, []);


  return (
    <div className="menu-carousel-container">
      <Carousel
        autoPlay={true}
        infiniteLoop={true}
        showThumbs={false}
        showArrows={false}
        showStatus={false}
      >
        {allImages.map((item, index) => {
          return (
            <div
              key={"slide" + index}
              className="menu-carousel-image-container"
            >
              <img
                className="menu-carousel-image"
                id={"scroll" + index}
                src={item.link}
                alt="thing"
              />
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}
